<template>
	<div class="signup-popup signup-step-3">
		<transition name="fade">
			<template v-if="!showVerifyPopup">
				<form @submit.prevent="onSubmit">
					<div class="popup-wrapper">
						<div class="popup-content">
							<h1 class="popup-title text-left">Business Details</h1>
							<p>
								<input
									type="text"
									placeholder="Business Name"
									required
									maxlength="100"
									v-model="formData.name"
								/>
							</p>
							<p>
								<input
									type="text"
									placeholder="Registration Number"
									maxlength="100"
									v-model="formData.registrationNumber"
								/>
							</p>
							<p>
								<textarea v-model="formData.address" maxlength="100" placeholder="Address" />
							</p>
							<p>
								<input
									type="text"
									placeholder="Postal Code"
									maxlength="100"
									v-model="formData.postalCode"
								/>
							</p>
							<p>
								<input type="text" placeholder="City" maxlength="100" v-model="formData.city" />
							</p>
							<p v-if="$store.state.ref && $store.state.ref.countries">
								<select v-model="formData.country">
									<option value="">Country</option>
									<option
										v-for="country in $store.state.ref.countries"
										:key="country.id"
										:value="country.id"
										>{{ country.title }}</option
									>
								</select>
							</p>
							<p v-if="$store.state.ref && $store.state.ref.industries">
								<select v-model="formData.industry">
									<option value="">Industry</option>
									<option
										v-for="industry in $store.state.ref.industries"
										:key="industry.id"
										:value="industry.id"
										>{{ industry.title }}</option
									>
								</select>
							</p>
							<!-- <h1 class="popup-title text-left">Verify Business</h1>
							<p class="text-left">
								To claim experiences, you need to be a verified business. This can be done by uploading
								a business verification document. This can be done at any later stage in your account
								manager as well.
							</p>
							<p>
								<a href="javascript:void(0);" class="btn btn-default" @click="onClickVerifyBusiness">
									<span>Verify Business</span>
								</a>
							</p> -->
						</div>
					</div>
					<div class="popup-actions">
						<a href="javascript:void(0);" class="text-button" @click="onClickBack">Back</a>
						<a href="javascript:void(0);" class="text-button" @click="onSkip">Skip</a>
						<button type="submit" class="btn btn-primary" :disabled="!isFormValid">Complete</button>
					</div>
				</form>
			</template>
		</transition>
		<transition name="fade">
			<template v-if="showVerifyPopup">
				<form @submit.prevent="onSubmitVerifyBusiness">
					<div class="popup-wrapper">
						<div class="popup-content">
							<h1 class="popup-title text-left">Business Verification</h1>
							<p>
								Upload a copy of your company registration or business license to verify your business.
							</p>
							<FileUploader
								label="Verification"
								@change="onVerifyDocumentChange"
								:files="formData.verificationDocumentFile ? [formData.verificationDocumentFile] : []"
							/>
						</div>
					</div>
					<div class="popup-actions">
						<a href="javascript:void(0);" class="text-button" @click="onCancelVerifyBusiness">Cancel</a>
						<button type="submit" class="btn btn-primary" :disabled="!tempVerificationDocumentFile">
							Verify
						</button>
					</div>
				</form>
			</template>
		</transition>
	</div>
</template>

<script>
import FileUploader from '@/components/FileUploader';

export default {
	components: {
		FileUploader,
	},
	data() {
		return {
			formData: {
				name: '',
				registrationNumber: '',
				address: '',
				postalCode: '',
				city: '',
				country: '',
				industry: '',
				verificationDocumentFile: null,
			},
			showVerifyPopup: false,
			tempVerificationDocumentFile: null,
		};
	},
	computed: {
		isFormValid() {
			let valid = true;
			if (!this.formData.name || this.formData.name.trim() === '') valid = false;

			return valid;
		},
	},
	methods: {
		onClickBack() {
			this.$emit('back');
		},
		onSubmit() {
			if (!this.isFormValid) return;

			this.formData.name = this.formData.name.trim();
			this.formData.registrationNumber = this.formData.registrationNumber.trim();
			this.formData.address = this.formData.address.trim();
			this.formData.postalCode = this.formData.postalCode.trim();
			this.formData.city = this.formData.city.trim();
			this.formData.country = this.formData.country.trim();
			this.formData.industry = this.formData.industry.trim();
			this.$store.commit('setSignupBusiness', this.formData);

			this.emitSubmit();
		},
		onSkip() {
			this.$emit('skip');
		},
		onVerifyDocumentChange(files) {
			if (files && files.length > 0) {
				this.tempVerificationDocumentFile = files[0];
			} else {
				this.tempVerificationDocumentFile = undefined;
			}
		},
		emitSubmit() {
			this.$emit('submit', this.formData);
		},
		loadFromStore() {
			this.formData.name = this.$store.state.signup.business.name;
			this.formData.registrationNumber = this.$store.state.signup.business.registrationNumber;
			this.formData.address = this.$store.state.signup.business.address;
			this.formData.postalCode = this.$store.state.signup.business.postalCode;
			this.formData.city = this.$store.state.signup.business.city;
			this.formData.country = this.$store.state.signup.business.country;
			this.formData.industry = this.$store.state.signup.business.industry;
			this.formData.verificationDocumentFile = this.$store.state.signup.business.verificationDocumentFile;
		},
		onClickVerifyBusiness() {
			this.showVerifyPopup = true;
		},
		onCancelVerifyBusiness() {
			this.showVerifyPopup = false;
			this.formData.verificationDocumentFile = null;
			this.tempVerificationDocumentFile = null;
		},
		onSubmitVerifyBusiness() {
			this.formData.verificationDocumentFile = this.tempVerificationDocumentFile;
			this.showVerifyPopup = false;
		},
	},
	mounted() {
		this.loadFromStore();
	},
};
</script>

<style lang="scss"></style>
